export { ConsoleTransport } from './transport';
export type { ConsoleTransportOptions } from './types';



// WEBPACK FOOTER //
// ../../../../src/transports/console/index.ts